import { render, staticRenderFns } from "./PuppyReleaseList.vue?vue&type=template&id=557f208d"
import script from "./PuppyReleaseList.vue?vue&type=script&lang=ts"
export * from "./PuppyReleaseList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports